export const verifyGoogleTag = () => {
  console.log('Checking Google Tag implementation...');
  
  // Check if gtag is available
  if (typeof window.gtag === 'function') {
    console.log('✅ gtag is properly loaded');
    
    // Send a test event
    window.gtag('event', 'debug_test', {
      event_category: 'debugging',
      event_label: 'Google Tag Verification',
      timestamp: new Date().toISOString()
    });
  } else {
    console.error('❌ gtag is not loaded properly');
  }

  // Check if dataLayer is available
  if (Array.isArray(window.dataLayer)) {
    console.log('✅ dataLayer is properly initialized');
    
    // Send a test event to dataLayer
    window.dataLayer.push({
      event: 'debug_test',
      category: 'debugging',
      label: 'GTM Verification',
      timestamp: new Date().toISOString()
    });
  } else {
    console.error('❌ dataLayer is not initialized properly');
  }

  // Log current dataLayer state
  console.log('Current dataLayer state:', window.dataLayer);
}; 